/**
 * Determine if move is first node in line
 */
export function isFirstNodeInLine(moveId: number): boolean {
  return moveId === -1;
}
